export default function(_parent,_CONTEXT){

  _parent.env = {
    init:function()
    {
      try
      {
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)))
        {
          this.isMobile = true;
        }
        else
        {
          this.isMobile = false;
        }


        // Check for cookies
        this.cookieEnabled = navigator.cookieEnabled;
        if (!this.cookieEnabled){
          document.cookie = "testcookie";
          this.cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
        }

        // Check for PWA support
        this.pwa_supportsmanifest = ('relList' in HTMLLinkElement.prototype && document.createElement('link').relList.supports('manifest')?true:false);

        //Set Useragent
        this.userAgent=navigator.userAgent;

        // Set Browser
        this.browser='unknown';
        if (/rv:11.0/i.test(navigator.userAgent)) {
          this.browser="IE";
        }

        if (/MSIE 10/i.test(navigator.userAgent)) {
          this.browser="IE_10";
        }
        else if (/MSIE 9/i.test(navigator.userAgent)) {
          this.browser="IE_9";

        }else if (/Edge\/\d./i.test(navigator.userAgent)){
          this.browser="IE_EDGE";
        }

        if(navigator.userAgent.includes('Chrome') &&
        !navigator.userAgent.includes('Chromium') &&
        !navigator.userAgent.includes('OPR') &&
        !navigator.userAgent.includes('Edge') &&
        !navigator.userAgent.includes('SamsungBrowser'))
        {
          this.browser="Chrome";
        }

        if(navigator.userAgent.includes('SamsungBrowser'))
        {
          this.browser="SamsungBrowser";
        }

        if(navigator.userAgent.includes('Firefox') || navigator.userAgent.includes('Seamonkey') || navigator.userAgent.includes('Focus'))
        {
          this.browser="Firefox";
        }


        if(navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome') &&
        !navigator.userAgent.includes('Chromium') &&
        !navigator.userAgent.includes('Android'))
        {
          this.browser="Safari";
          if(navigator.userAgent.includes('CriOS'))
          {
            this.browser="Safari/Chrome";
          }
          else if(navigator.userAgent.includes('FxiOS'))
          {
            this.browser="Safari/Firefox";
          }
          else if(navigator.userAgent.includes('DuckDuckGo'))
          {
            this.browser="Safari/DuckDuckGo";
          }
          else if(navigator.userAgent.includes('EdgiOS'))
          {
            this.browser="Safari/EdgiOS";
          }

        }

        // Set OS
        this.OS = 'unknown';
        let clientStrings = [
          {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
          {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
          {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
          {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
          {s:'Windows Vista', r:/Windows NT 6.0/},
          {s:'Windows Server 2003', r:/Windows NT 5.2/},
          {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
          {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
          {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
          {s:'Windows 98', r:/(Windows 98|Win98)/},
          {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
          {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
          {s:'Windows CE', r:/Windows CE/},
          {s:'Windows 3.11', r:/Win16/},
          {s:'Android', r:/Android/},
          {s:'Open BSD', r:/OpenBSD/},
          {s:'Sun OS', r:/SunOS/},
          {s:'Chrome OS', r:/CrOS/},
          {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
          {s:'iOS', r:/(iPhone|iPad|iPod)/},
          {s:'Mac OS X', r:/Mac OS X/},
          {s:'Mac OS', r:/(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
          {s:'QNX', r:/QNX/},
          {s:'UNIX', r:/UNIX/},
          {s:'BeOS', r:/BeOS/},
          {s:'OS/2', r:/OS\/2/},
          {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (let id in clientStrings) {
          let cs = clientStrings[id];
          if (cs.r.test(navigator.userAgent)) {
              this.OS = cs.s;
              break;
          }
        }

        this.OSVersion = 'unknown';


        if (/Windows/.test(this.OS)) {
          this.OSVersion = /Windows (.*)/.exec(this.OS)[1];
          this.OS = 'Windows';
        }

        switch (this.OS) {
          case 'Mac OS':
          case 'Mac OS X':
                this.OSVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(navigator.userAgent)[1];
                break;
          case 'Android':
              this.isMobile = true;
              this.OSVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(navigator.userAgent)[1];
              break;
          case 'iOS':
              this.isMobile = true;
              this.OSVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
              this.OSVersion = this.OSVersion[1] + '.' + this.OSVersion[2] + '.' + (this.OSVersion[3] | 0);
              break;
        }

        if (/Mac OS/.test(this.OS) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
          this.OS = 'iOS';
          this.isMobile = true;
        }

        if(this.OS!==null)
        {
          this.OS = this.OS.replace(' ','').toLowerCase();
        }
        if(this.OSVersion!==null)
        {
          this.OSVersion = this.OSVersion.replace(' ','').toLowerCase();
        }
        if(this.browser!==null)
        {
          this.browser = this.browser.replace(' ','').toLowerCase();
        }

      }
      catch(ex)
      {
        _parent.env._log("error","env.init",ex);
      }

      this.viewPortSizes = {};
    },
    get: function()
    {
      return {'os':this.OS,
        'os_version':this.OSVersion,
        'browser':this.browser,
        'viewport': this.viewPort,
        'pwa_support':{'manifest':this.pwa_supportsmanifest},
        'is_mobile':this.isMobile,
        'isInstalled':this.isInstalled,
        'userAgent':this.userAgent
      };
    },
    getOS: function()
    {
      return this.OS;
    },
    getOSVersion: function()
    {
      return this.OSVersion;
    },
    isInstalled:function()
    {
      let result = false;
      // For iOS
      if(window.navigator.standalone)
      {
        result = true;
      }

      // For Android
      if(window.matchMedia('(display-mode: standalone)').matches)
      {
        result = true;
      }
      return result;

    },
    print: function()
    {
      _parent.env._log("info","env.getOS/env.getOSVersion/env.userAgent/env.Browser",this.getOS()+'/'+this.getOSVersion()+'/'+this.userAgent+'/'+this.browser);
      _parent.env._log("info","env.isInstalled",this.isInstalled());
      _parent.env._log("info","env.getViewport","Width:"+window.innerWidth+', Viewport is '+this.viewPort);
      if(('dimentions' in this) && typeof this.dimentions == 'object')
      {
        _parent.env._log("info","env.getDimentions","fullheight:"+this.dimentions.fullheight+', fullwidth:'+this.dimentions.fullwidth);
      }
    },
    refreshViewPort:function(){
      let dsb_app_defines = document.createElement("div");
      dsb_app_defines.setAttribute('id','dsb_app_defines');
      dsb_app_defines.innerHTML = `<div id="dsb_app_defines-large" class="define-large"></div><div id="dsb_app_defines-medium" class="define-medium"></div><div id="dsb_app_defines-small" class="define-small"></div><div id="dsb_app_defines-xsmall" class="define-xsmall"></div>`;
      document.querySelector('dsb-app').append(dsb_app_defines);
      this.viewPortSizes.large=document.getElementById( "dsb_app_defines-large" ).offsetWidth;
      this.viewPortSizes.medium=document.getElementById( "dsb_app_defines-medium" ).offsetWidth;
      this.viewPortSizes.small=document.getElementById( "dsb_app_defines-small" ).offsetWidth;
      this.viewPortSizes.xsmall=document.getElementById( "dsb_app_defines-xsmall" ).offsetWidth;
      document.getElementById( "dsb_app_defines" ).remove();
      this.dimentions={};
      this.dimentions.fullheight=getComputedStyle(document.documentElement).getPropertyValue('--fullheight');
      this.dimentions.fullwidth=getComputedStyle(document.documentElement).getPropertyValue('--fullwidth');
      this.getDimentions();
      this.isInstalled();
      this.getOS();
      this.getOSVersion();
      this.print();
      return this.getViewport(true);
    },
    getComputedStyle(property)
    {
      return getComputedStyle(document.documentElement).getPropertyValue(property);
    },
    getViewport:function(force){
      if(force)
      {
        var width = window.innerWidth;
        if(width<=this.viewPortSizes.medium && width>this.viewPortSizes.small)
        {
          this.viewPort='medium';
        }
        else if(width<=this.viewPortSizes.small && width>this.viewPortSizes.xsmall)
        {
          this.viewPort='small';
        }
        else if(width<=this.viewPortSizes.xsmall)
        {
          this.viewPort='xsmall';
        }
        else
        {
          this.viewPort='large';
        }
      }
      return this.viewPort;
    },
    getDimentions:function(){
      return this.dimentions;
    },
    isViewport: function(_portSize)
    {
      let portSize = [];
      if(!Array.isArray(_portSize))
      {
        portSize.push(_portSize );
      }
      else
      {
        portSize = _portSize;
      }

      for(let i = 0; i < portSize.length; i++)
      {
        if(this.viewPort.toLowerCase()===portSize[i].toLowerCase())
        {
          return true;
        }
      }
      return false;
    },
    getContext: function(name,on_error_callback=false)
    {
      if(typeof name === 'string' && name.length>0)
      {
        if(name in _CONTEXT)
        {
          return JSON.parse(JSON.stringify(_CONTEXT[name]));
        }
        else
        {
          if(typeof on_error_callback === 'function')
          {
            return on_error_callback();
          }
        }
        return;
      }
      else
      {
        return JSON.parse(JSON.stringify(_CONTEXT));
      }
    }
  };
  _parent.env._log = function(type,source,message,data='')
  {
    _parent._log(type,source,message,data,'env');
  };
  _parent.env.init();

  window.onresize = function() {
    _parent.env.getViewport(true);
    _parent.env.print();
  }
  _parent.env._log('debug','init','Available');

}
